module.exports = __webpack_public_path__ + "img/40_38_055_750.db4ffd77.jpg";